/* lc-checkout-loading.js — La Carnicerie
 * Muestra "Procesando…" + spinner en el botón Comprar mientras Shopify crea el
 * checkout (~3-5s), para que no parezca pegado. No cancela el envío (aplica el
 * estado en setTimeout 0). Restaura a los 15s por si el checkout no redirige.
 * Fail-open: cualquier error no afecta el flujo. */
(function () {
  'use strict';
  try {
    var st = document.createElement('style');
    st.textContent = '.lc-spin{display:inline-block;width:14px;height:14px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;vertical-align:-2px;margin-right:7px;animation:lcspin .6s linear infinite}@keyframes lcspin{to{transform:rotate(360deg)}}';
    (document.head || document.documentElement).appendChild(st);
    document.addEventListener('click', function (e) {
      var t = e.target;
      var btn = (t && t.closest) ? t.closest('button[name="checkout"],input[name="checkout"]') : null;
      if (!btn || btn.dataset.lcLoading) return;
      setTimeout(function () {
        if (btn.dataset.lcLoading) return;
        btn.dataset.lcLoading = '1';
        var isInput = btn.tagName === 'INPUT';
        if (btn.dataset.lcOrig === undefined) btn.dataset.lcOrig = isInput ? btn.value : btn.innerHTML;
        if (isInput) btn.value = 'Procesando…';
        else btn.innerHTML = '<span class="lc-spin" aria-hidden="true"></span> Procesando…';
        btn.style.pointerEvents = 'none'; btn.style.opacity = '.9'; btn.setAttribute('aria-busy', 'true');
        setTimeout(function () {
          if (btn.dataset.lcOrig === undefined) return;
          if (btn.tagName === 'INPUT') btn.value = btn.dataset.lcOrig; else btn.innerHTML = btn.dataset.lcOrig;
          btn.style.pointerEvents = ''; btn.style.opacity = ''; btn.removeAttribute('aria-busy');
          delete btn.dataset.lcLoading; delete btn.dataset.lcOrig;
        }, 15000);
      }, 0);
    }, true);
  } catch (e) { /* fail-open */ }
})();
